// extracted by mini-css-extract-plugin
module.exports = {"errorPageContainer":"errorPageContainer_z60gj","imgContainer":"imgContainer_1L9WM","textContainer":"textContainer_2JwhM"};